import React from 'react';
import { Sparkles, Eye, Star } from 'lucide-react';

const MediumVoyant = () => {
  return (
    <section className="py-16 md:py-32 px-4 relative overflow-hidden bg-black">
      <div className="absolute top-1/3 right-1/4 w-96 h-96 bg-yellow-600/5 rounded-full blur-3xl"></div>
      
      <div className="container mx-auto relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-5xl md:text-6xl font-bold text-white mb-6 display-font">
            <span className="gold-text">Marabout Voyant Medium</span> Professionnel
          </h2>
          <div className="w-32 h-1 divider-glow mx-auto mb-6"></div>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto serif-font">
            Services de voyance, médiumnité et maraboutage avec plus de 20 ans d'expérience
          </p>
        </div>
        
        <div className="grid md:grid-cols-3 gap-8 mb-16">
          <div className="glass rounded-3xl p-8 text-center card-hover">
            <div className="w-20 h-20 bg-gradient-to-br from-yellow-600 to-amber-600 rounded-full flex items-center justify-center mx-auto mb-6 shadow-lg">
              <Sparkles className="text-white" size={40} />
            </div>
            <h3 className="text-2xl font-bold text-white mb-4 display-font">Marabout Sérieux</h3>
            <p className="text-gray-300 leading-relaxed">
              <strong className="text-yellow-500">Marabout professionnel et efficace</strong>, spécialisé dans les rituels de retour affectif, 
              envoûtement d'amour et magie africaine traditionnelle. Un <strong>marabout puissant</strong> reconnu pour ses résultats rapides.
            </p>
          </div>
          
          <div className="glass rounded-3xl p-8 text-center card-hover">
            <div className="w-20 h-20 bg-gradient-to-br from-yellow-600 to-amber-600 rounded-full flex items-center justify-center mx-auto mb-6 shadow-lg">
              <Eye className="text-white" size={40} />
            </div>
            <h3 className="text-2xl font-bold text-white mb-4 display-font">Voyant Efficace</h3>
            <p className="text-gray-300 leading-relaxed">
              <strong className="text-yellow-500">Voyant sérieux et medium puissant</strong>, capable de voir votre avenir et de vous guider 
              dans vos décisions. Un <strong>voyant marabout</strong> qui combine voyance et rituels pour des résultats concrets.
            </p>
          </div>
          
          <div className="glass rounded-3xl p-8 text-center card-hover">
            <div className="w-20 h-20 bg-gradient-to-br from-yellow-600 to-amber-600 rounded-full flex items-center justify-center mx-auto mb-6 shadow-lg">
              <Star className="text-white" size={40} />
            </div>
            <h3 className="text-2xl font-bold text-white mb-4 display-font">Medium Sérieux</h3>
            <p className="text-gray-300 leading-relaxed">
              <strong className="text-yellow-500">Medium marabout africain</strong> avec des dons authentiques de médiumnité. 
              Un <strong>medium efficace</strong> pour la communication spirituelle et la résolution de vos problèmes.
            </p>
          </div>
        </div>
        
        <div className="max-w-5xl mx-auto glass rounded-3xl p-10">
          <h3 className="text-3xl font-bold text-white mb-6 display-font text-center">
            Marabout Voyant Medium : Expertise Triple pour Résultats Garantis
          </h3>
          <div className="text-gray-300 leading-relaxed space-y-4">
            <p>
              En tant que <strong className="text-yellow-500">marabout voyant medium</strong>, je combine trois expertises complémentaires pour vous offrir 
              les meilleurs résultats. Un <strong>voyant marabout</strong> possède la capacité de voir l'avenir tout en pratiquant les rituels nécessaires 
              pour transformer votre destinée.
            </p>
            <p>
              Un <strong className="text-yellow-500">marabout medium</strong> établit un lien avec le monde spirituel pour comprendre les énergies qui vous entourent. 
              Cette triple compétence de <strong>marabout voyant medium sérieux</strong> permet d'identifier les blocages et d'appliquer les solutions adaptées 
              à votre situation unique.
            </p>
            <p>
              Que vous cherchiez un <strong className="text-yellow-500">marabout efficace</strong>, un <strong>voyant sérieux</strong> ou un 
              <strong> medium puissant</strong>, vous trouverez ici une expertise complète. Le <strong>voyant medium</strong> voit ce que d'autres ne voient pas, 
              le <strong>marabout discret</strong> agit avec la plus grande confidentialité, et le <strong>medium marabout</strong> canalise les énergies 
              pour votre bien-être.
            </p>
            <p>
              Services de <strong className="text-yellow-500">marabout voyant</strong> disponibles pour le retour affectif, l'envoûtement d'amour, 
              la protection spirituelle, le désenvoûtement, la chance aux jeux et la réussite professionnelle. Un <strong>marabout puissant</strong> 
              qui travaille avec discrétion et efficacité pour transformer votre vie.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MediumVoyant;